import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from './services/locale.service';

@Pipe({
  name: 'locale',
  standalone: false
})
export class LocalePipe implements PipeTransform {

  constructor(private localization: LocaleService) {}

  transform(key: string, params?: { [key: string]: string }, upperCase = false): string {
    let text = this.localization.getString(key) || key;

    if (params) {
      Object.keys(params).forEach(paramKey => {
        const placeholder = `__${paramKey}__`;
        text = text.replace(new RegExp(placeholder, 'g'), params[paramKey]);
      });
    }

    return upperCase ? text.toUpperCase() : text;
  }

}
